import React from "react";
import {useSelector} from "react-redux";

function ARankTitle(props) {
    const rows = useSelector((state) => state.rows.value)


    function createStyle(rank) {
        return {
            fontSize: "min(48px, " + 5 / rows + "vw)",
            display: "compact",
            textAlign: "left",
            color: rank === 1 ? "#6666ff" : "#66d7bb",
            position: "absolute",
            marginLeft: "min(10px, 1vw)",
            marginBlockStart: rank === 1 ? 0 : "1em",
            fontFamily: "\"Segoe UI\", Arial, sans-serif",
            padding: 0,
            zIndex: 1,
            textShadow: "-1px -1px 0 #000, 0 -1px 0 #000, 1px -1px 0 #000, 1px 0 0 #000, 1px 1px 0 #000, 0 1px 0 #000, -1px 1px 0 #000, -1px 0 0 #000"
        }
    }

    let instance = ' ' + props.instance
    if (props.instanceCount === 1) instance = ''

    return (
        <h2 key={props.name + props.instance + props.rank + "h2"} style={createStyle(props.rank)}>
            {props.name + instance}
        </h2>)
}

export default ARankTitle